module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c(_vm.el, {
    tag: "component",
    attrs: {
      "label": _vm.label,
      "required": _vm.required
    }
  }, [(_vm.noForm) ? _c('i', [_vm._v(_vm._s(_vm.label) + " ")]) : _vm._e(), _vm._v(" "), _c('select-input', {
    attrs: {
      "label": _vm.label,
      "value-key": "value",
      "label-value": "label",
      "placeholder": _vm.placeholder,
      "size": _vm.size,
      "list": _vm.selects,
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c23fc74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/selects/SelectUtility.vue
// module id = 1599
// module chunks = 0